import { serviceMaker, methods, api } from "../index";

export const getIpManagementList = () =>
  serviceMaker(`/ippooling?limit=14&offset=0`, methods.GET, api.NGB);

export const getManagementInfo = () =>
  serviceMaker(`/ippooling/template`, methods.GET, api.NGB);

export const updateManagementInfo = (payload) =>
  serviceMaker(`/ippooling/${payload.id}`, methods.PUT, api.NGB, payload.data);
